export class SetSelectedTabEventBroker {
    constructor(public readonly panel: any) {
    }
    public static EventSelector(eventInfo: any): boolean {
        return eventInfo instanceof SetSelectedTabEventBroker;
    }
}
